// extracted by mini-css-extract-plugin
export default {"disabledForm":"styles_disabledForm__hkIhh","wrapper":"styles_wrapper__2byAR","footer":"styles_footer__rf4Sv","generatePasswordButton":"styles_generatePasswordButton__Jqz40"};